var _circle, _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 37.5,
    fill: "#D46A19"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Email_svg__a)",
    fill: "#FBFAFA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.33 25.999a2.006 2.006 0 0 0-.41 0h-28c-.179.003-.357.03-.53.08l14.45 14.39 14.49-14.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.81 27.39-14.56 14.5a2 2 0 0 1-2.82 0L21 27.5a1.998 1.998 0 0 0-.07.5v20a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V28a2.003 2.003 0 0 0-.12-.61ZM24.3 48h-1.39v-1.43l7.27-7.21 1.41 1.41L24.3 48Zm26.61 0h-1.4l-7.29-7.23 1.41-1.41 7.27 7.21.01 1.43Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Email_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(19 20)",
    d: "M0 0h36v36H0z"
  })))));
};

export default SvgEmail;